import { MenuItem } from "@/model/entities";
import { menuItemService } from "@/service/menuItemService";
import { useQuery } from "@tanstack/react-query";

export function useMenuItem(id: string) {
    const query = useQuery<MenuItem | null>({
        queryKey: ["menuItem", id],
        queryFn: () => menuItemService.getById(id),
        enabled: !!id,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });

    return { ...query };
}